<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>审批</el-breadcrumb-item>
      <el-breadcrumb-item>办公用品</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.spbuystatus" placeholder="请选择" style="width: 100%">
              <el-option label="请选择购买状态" value="-1"></el-option>
              <el-option label="未购买" value="0"></el-option>
              <el-option label="已购买" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="ShangJigouName" label="公司名称" min-width="8%"></el-table-column>
          <el-table-column prop="CurJigouName" label="申请部门" min-width="8%"></el-table-column>
          <el-table-column prop="Spname" label="名称" min-width="11%"></el-table-column>
          <el-table-column prop="Spdanwei" label="单位" min-width="9%"></el-table-column>
          <el-table-column prop="Spjiage" label="价格" min-width="4%"></el-table-column>
          <el-table-column prop="Spnum" label="数量" min-width="4%"></el-table-column>
          <el-table-column prop="Spjine" label="金额" min-width="4%"></el-table-column>
          <el-table-column prop="Spstatusname" label="审批状态" min-width="8%"></el-table-column>
          <el-table-column prop="Spbuystatusname" label="购买状态" min-width="5%"></el-table-column>
          <el-table-column prop="Name1" label="申请人" min-width="5%"></el-table-column>
          <el-table-column prop="Name2" label="部门主管" min-width="5%"></el-table-column>
          <el-table-column prop="Name3" label="总经办" min-width="5%"></el-table-column>
          <el-table-column prop="Name4" label="人事" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="申请日期" min-width="11%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Spstatus == 1" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Spstatus == 1 && SubRule_ShenPiBanGongYongPing_BuMen" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe1(scope.row)">部门主管审核</el-button>
              <el-button v-if="scope.row.Spstatus == 2 && SubRule_ShenPiBanGongYongPing_DanWeiZong" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="ShenHe2(scope.row)">总经办审核</el-button>
              <el-button v-if="scope.row.Spstatus == 3 && scope.row.Spbuystatus == 1 && SubRule_ShenPiBanGongYongPing_RenShi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickbuy(scope.row,0)">未购买</el-button>
              <el-button v-if="scope.row.Spstatus == 3 && scope.row.Spbuystatus == 0 && SubRule_ShenPiBanGongYongPing_RenShi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickbuy(scope.row,1)">已购买</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <el-dialog
          title="审批"
          :visible.sync="dialogVisible"
          width="20%">
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="ShenHeOK">同意</el-button>
            <el-button type="danger" @click="ShenHeNO">拒绝</el-button>
          </span>
        </el-dialog>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="办公用品/固定资产申购" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">名称(必填)</span>
          </label>
          <el-input type="textarea" :rows="3" v-model="addForm.spname"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">单位(必填)</span>
          </label>
          <el-input v-model="addForm.spdanwei"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">价格(必填)</span>
          </label>
          <el-input v-model="addForm.spjiage"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">数量(必填)</span>
          </label>
          <el-input v-model="addForm.spnum"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="addForm.spjine"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal
  },
  name: 'MyShenPiBanGongYongPing',
  data () {
    return {
      activeName: 'first',
      addForm: {
        spname: '',
        spdanwei: '',
        spjiage: '',
        spnum: '',
        spjine: ''
      },
      // 查询
      keywords: {
        jigouid: '-1',
        jigouname: '',
        spbuystatus: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiBanGongYongPingSHUrl: '',
      spid: 0,
      SubRule_ShenPiBanGongYongPing_BuMen: false,
      SubRule_ShenPiBanGongYongPing_DanWeiZong: false,
      SubRule_ShenPiBanGongYongPing_RenShi: false
    }
  },
  mounted () {
    this.apiGetShenPiBanGongYongPingNum()
    this.apiGetShenPiBanGongYongPingList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBanGongYongPing_BuMen', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBanGongYongPing_BuMen = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBanGongYongPing_DanWeiZong', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBanGongYongPing_DanWeiZong = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiBanGongYongPing_RenShi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiBanGongYongPing_RenShi = true
      }
    })
  },
  methods: {
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickadd () {
      this.apiAddShenPiBanGongYongPing()
    },
    clicksave () {
      this.apiEditShenPiBanGongYongPing()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    ShenHe1 (row) {
      this.dialogVisible = true
      this.apiShenPiBanGongYongPingSHUrl = Vue.prototype.global.Url_ShenPiBanGongYongPingSH1
      this.spid = row.Id
    },
    ShenHe2 (row) {
      this.dialogVisible = true
      this.apiShenPiBanGongYongPingSHUrl = Vue.prototype.global.Url_ShenPiBanGongYongPingSH2
      this.spid = row.Id
    },
    ShenHeOK () {
      this.dialogVisible = false
      this.apiShenPiBanGongYongPingSH(1)
    },
    ShenHeNO () {
      this.dialogVisible = false
      this.apiShenPiBanGongYongPingSH(-1)
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelShenPiBanGongYongPing(row.Id)
      })
    },
    clickbuy (row, spbuystatus) {
      this.apiChangeBanGongYongPingBuyStatus(row.Id, spbuystatus)
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetShenPiBanGongYongPingNum()
      this.apiGetShenPiBanGongYongPingList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetShenPiBanGongYongPingList()
    },
    apiGetShenPiBanGongYongPingNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        spbuystatus: that.keywords.spbuystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiBanGongYongPingNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetShenPiBanGongYongPingList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        spbuystatus: that.keywords.spbuystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiBanGongYongPingList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddShenPiBanGongYongPing: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spname: that.addForm.spname,
        spdanwei: that.addForm.spdanwei,
        spjiage: that.addForm.spjiage,
        spnum: that.addForm.spnum,
        spjine: that.addForm.spjine
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddShenPiBanGongYongPing, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBanGongYongPingNum()
            that.apiGetShenPiBanGongYongPingList()

            // 清空添加
            that.addForm.spname = ''
            that.addForm.spdanwei = ''
            that.addForm.spjiage = ''
            that.addForm.spnum = ''
            that.addForm.spjine = ''
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelShenPiBanGongYongPing: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelShenPiBanGongYongPing, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBanGongYongPingNum()
            that.apiGetShenPiBanGongYongPingList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiShenPiBanGongYongPingSH: function (okorno) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: that.spid,
        okorno: okorno
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(that.apiShenPiBanGongYongPingSHUrl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetShenPiBanGongYongPingNum()
            that.apiGetShenPiBanGongYongPingList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiChangeBanGongYongPingBuyStatus: function (spid, spbuystatus) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        spid: spid,
        spbuystatus: spbuystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ChangeBanGongYongPingBuyStatus, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetShenPiBanGongYongPingNum()
            that.apiGetShenPiBanGongYongPingList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
